/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Absence_Reason_AnnualleaveInputs */

const en_enum_absence_reason_annualleave = /** @type {(inputs: Enum_Absence_Reason_AnnualleaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason Annualleave`)
};

const de_enum_absence_reason_annualleave = /** @type {(inputs: Enum_Absence_Reason_AnnualleaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund Annualleave`)
};

/**
* | output |
* | --- |
* | "Reason Annualleave" |
*
* @param {Enum_Absence_Reason_AnnualleaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_absence_reason_annualleave = /** @type {((inputs?: Enum_Absence_Reason_AnnualleaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Absence_Reason_AnnualleaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_absence_reason_annualleave(inputs)
	return de_enum_absence_reason_annualleave(inputs)
});